// @flow

import * as React from 'react';

import Card from 'sail/Card';
import {formatLanguage} from 'docs/util/integration-builder/formatLanguage';
import Notice from 'sail/Notice';
import {usePrefs} from 'docs/data';
import type {VideoModelWithTopic} from 'docs/data';
import {getMismatchedPrefsForVideo} from './data/util';

export const MissingPrefsCallout = ({video}: {video: VideoModelWithTopic}) => {
  const {getPref} = usePrefs();
  const prefs = {
    lang: getPref('lang'),
    client: getPref('client'),
    platform: getPref('platform'),
  };
  const {expected, actual, mismatchedPrefs} = getMismatchedPrefsForVideo(
    video,
    prefs,
  );

  if (mismatchedPrefs <= 0) {
    return null;
  }

  const expectedPref = formatLanguage(expected[0].prefValue);
  const actualPref = formatLanguage(actual[0].prefValue);

  const description = `We don’t have a video on this topic for ${expectedPref} yet. Here’s one for ${actualPref} instead.`;
  return (
    <Card shadow="keyline">
      <Notice
        description={description}
        divider={false}
        icon="info"
        color="yellow"
      />
    </Card>
  );
};
